module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Roots of Evil")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("By K.C. Wells")]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("Sequel to "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Truth Will Out")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Norm-NoIndent"
  }, [_vm._v("A Merrychurch Mysteries Case")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Many consider Naomi Teedle the village witch. Most people avoid her except when they have need of her herbs and potions. She lives alone on the outskirts of Merrychurch, and that’s fine by everyone—old Mrs. Teedle is not the most pleasant of people. But when she is found murdered, her mouth bulging with her own herbs and roots, suddenly no one has a bad word to say about her.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Jonathon de Mountford is adjusting to life up at the manor house, but it’s not a solitary life: pub landlord Mike Tattersall sees to that. Jonathon is both horrified to learn of the recent murder and confused by the sudden reversal of public opinion. Surely someone in the village had reason to want her dead? He and Mike decide it’s time for them to step in and “help” the local police with their investigation. Only problem is, their sleuthing uncovers more than one suspect—and the list is getting longer….")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34aefee5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0002.vue
// module id = 60
// module chunks = 0